/**
 * home-hero-banner.js
 * 用途: 首页主 Hero Banner 的交互逻辑（倒计时 + 背景视差；图片断点缩放已由 CSS @container 接管）
 * 依赖: 纯原生 JS；Parallax 仅在开启时按需动态加载 gsap + ScrollTrigger
 * 使用: sections/home-hero-banner.liquid 内以 defer 引入
 * 说明: 配置通过 DOM data 属性传递，不依赖具体 section.id，支持页面多实例
 */
;(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* ── 1. 倒计时 ── */
  function initCountdown(el) {
    var endStr = el.dataset.hhbCountdown;
    if (!endStr) return;

    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    /* 读取时数上限，默认 99，最大不超过 99 */
    var hourCap = parseInt(el.dataset.hhbHourCap, 10);
    if (isNaN(hourCap) || hourCap < 0) hourCap = 99;
    if (hourCap > 99) hourCap = 99;

    var hEl = el.querySelector('[data-hhb-unit="h"]');
    var mEl = el.querySelector('[data-hhb-unit="m"]');
    var sEl = el.querySelector('[data-hhb-unit="s"]');

    function tick() {
      var now = Date.now();
      var diff = endTime - now;

      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }

      var totalSec = Math.floor(diff / 1000);
      var h = Math.min(Math.floor(totalSec / 3600), hourCap);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;

      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);

      setTimeout(tick, 1000);
    }

    tick();
  }

  /* ── 2. Parallax 视差 ── */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initParallaxEl(root) {
    var inner = root.querySelector('.hhb__inner');
    if (!inner) return;

    var bgLayers = inner.querySelectorAll('.hhb__bg-img, .hhb__bg-placeholder');
    if (!bgLayers.length) return;

    var strength = parseInt(root.dataset.hhbParallax, 10);
    if (isNaN(strength)) strength = 20;

    gsap.registerPlugin(ScrollTrigger);

    /* 仅在桌面端 + 用户不偏好减弱动效时启用；切换条件时自动撤销 */
    gsap.matchMedia().add('(min-width: 769px) and (prefers-reduced-motion: no-preference)', function () {
      gsap.to(bgLayers, {
        yPercent: strength,
        ease: 'none',
        scrollTrigger: {
          trigger: inner,
          start: 'top top',   /* 页面顶部：无变换 */
          end: 'bottom top',  /* banner 完全滚出视口：达到最大位移 */
          scrub: true
        }
      });
    });

    /* 图片加载完成后刷新测量，修正 ScrollTrigger 起始位置 */
    if (document.readyState === 'complete') {
      gsap.delayedCall(0.5, function () { ScrollTrigger.refresh(); });
    } else {
      window.addEventListener('load', function () {
        gsap.delayedCall(0.5, function () { ScrollTrigger.refresh(); });
      }, { once: true });
    }
  }

  function initAllParallax() {
    var roots = document.querySelectorAll('.hhb[data-hhb-parallax]');
    if (!roots.length) return;

    var gsapSrc = roots[0].dataset.hhbGsapSrc;

    function run() {
      roots.forEach(initParallaxEl);
    }

    function ensureSt() {
      if (typeof ScrollTrigger === 'undefined' && roots[0].dataset.hhbStSrc) {
        loadScript(roots[0].dataset.hhbStSrc).then(run).catch(function (){});
        return;
      }
      run();
    }

    /* 串行加载：先 gsap 再 ScrollTrigger（ScrollTrigger 依赖 gsap） */
    if (typeof gsap !== 'undefined' || !gsapSrc) {
      ensureSt();
    } else {
      loadScript(gsapSrc).then(ensureSt).catch(function (){});
    }
  }

  /* ── 启动 ── */
  document.querySelectorAll('.hhb [data-hhb-countdown]').forEach(initCountdown);
  initAllParallax();
})();